/**
 * The side-nav icons, drawn as in the zCRM mockups (Leads UX, Booking UX): 24px stroke icons
 * in the text color.
 */
import type { ReactNode } from "react";

export type NavIcon = (props: {
  className?: string;
  strokeWidth?: number;
}) => ReactNode;

const icon =
  (shapes: ReactNode): NavIcon =>
  ({ className }) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      {shapes}
    </svg>
  );

/** Today / dashboard: a clock. */
export const TodayIcon = icon(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </>,
);

/** Leads: a funnel. */
export const LeadsIcon = icon(<path d="M4 4h16l-6 8v6l-4 2v-8z" />);

/** Pipeline: board columns, shorter to the right. */
export const PipelineIcon = icon(
  <>
    <rect x="3" y="4" width="5" height="16" rx="1" />
    <rect x="10" y="4" width="5" height="11" rx="1" />
    <rect x="17" y="4" width="4" height="7" rx="1" />
  </>,
);

/** Accounts: a building. */
export const AccountsIcon = icon(
  <>
    <path d="M4 21V5l8-2 8 2v16" />
    <path d="M9 21v-4h6v4" />
  </>,
);

/** Contacts: a person. */
export const ContactsIcon = icon(
  <>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c1-4 4-6 8-6s7 2 8 6" />
  </>,
);
